import { memo } from "react";

import { type RFNode } from "../../types";
import { getNodeTitle } from "../utils/nodeUtils";
import { SourceHandle, TargetHandle } from "./Handle";
import { RoundedNodeIcon } from "./NodeIcon";
import NodeWrapper from "./NodeWrapper";

type Props = {
  id: string;
  data: RFNode;
  selected?: boolean;
};

const InternalFilterNode = ({ id, data, selected }: Props) => (
  <>
    <NodeWrapper
      title={getNodeTitle(data)}
      status={data.nodeData.status || "error"}
      onEdit={data.onEditNode}
      onDelete={data.onDeleteNode}
      isActive={!!selected}
      icon={<RoundedNodeIcon node={data} />}
      name={`${data.stepNumber}. ${data.nodeData.name || "Filter"}`}
    />
    <SourceHandle id={id} />
    <TargetHandle id={id} />
  </>
);

export const FilterNode = memo(InternalFilterNode);
